/** @jsx jsx */
import { jsx } from '@emotion/core'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { navigate } from 'gatsby'
import Mousetrap from 'mousetrap'

import { Box, Icon, Input, hooks } from '@planning-center/ui-kit'

function DocSearch(props) {
  const [enabled, setEnabled] = useState(true)
  const [value, setValue] = useState('')
  const inputRef = useRef(null)
  const { focus, focusProps } = hooks.useFocus()

  useLayoutEffect(() => {
    if (window.docsearch) {
      const search = window.docsearch({
        apiKey: 'd76ec35e5767e365bd86c934bf30f019',
        indexName: 'ministrycentered-ui-kit',
        inputSelector: '#algolia-doc-search',
      })
      search.autocomplete.off('autocomplete:selected')
      search.autocomplete.on('autocomplete:selected', (_, data) => {
        let url = data.url.replace('#gatsby-focus-wrapper', '')
        if (process.env.NODE_ENV === 'development') {
          url = url.split('ui-kit')[1]
        }
        navigate(url)
      })
    } else {
      console.warn('Search has failed to load and now is being disabled')
      setEnabled(false)
    }
  }, [])

  useEffect(() => {
    Mousetrap.bind('/', () => {
      if (inputRef.current) {
        const inputNode = inputRef.current.querySelector('input')
        if (inputNode) {
          // wait until next tick otherwise it will focus and insert backslash character
          setTimeout(() => {
            inputNode.focus()
          })
        }
      }
    })
    return () => {
      Mousetrap.unbind('/')
    }
  }, [])

  return enabled ? (
    <Box
      as="form"
      visible={false}
      mediaQueries={{ md: { visible: true } }}
      {...props}
    >
      <Input
        innerRef={(node) => (inputRef.current = node)}
        value={value}
        onChange={(event) => setValue(event.target.value)}
        id="algolia-doc-search"
        type="search"
        placeholder='Search docs (Press "/" to focus)'
        aria-label="Search docs"
        size="lg"
        renderLeft={<Icon name="search" color={focus ? 'dark-7' : 'light-5'} />}
        secondaryStroke={false}
        width="100%"
        placeholderColor={focus ? 'dark-6' : 'light-6'}
        backgroundColor="light-0"
        color="light-8"
        stroke="transparent"
        zIndex={9999}
        focus={{
          backgroundColor: 'white',
          stroke: 'dark-9',
          color: 'dark-9',
        }}
        {...focusProps}
      />
    </Box>
  ) : null
}

export default DocSearch
